import { css } from '@emotion/core';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var address = /*#__PURE__*/css(designTokenFonts.bodyBold);